import { render, staticRenderFns } from "./DatatableBody.vue?vue&type=template&id=06c8b1c4"
import script from "./DatatableBody.vue?vue&type=script&lang=js"
export * from "./DatatableBody.vue?vue&type=script&lang=js"
import style0 from "./DatatableBody.vue?vue&type=style&index=0&id=06c8b1c4&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports